import Footer from "../frontend/components/footer";
import Header from "../frontend/components/header";

const FrontLayout = ({ children }) => {

  return (<>
    <Header />
    {children}
    <Footer />
  </>);
}

export default FrontLayout;